module.exports = __webpack_public_path__ + "img/close.0f116392.svg";